import AmericanExpressLogo from '~/assets/img/creditCards/amex.svg';
import DinersClubLogo from '~/assets/img/creditCards/dinersclub.svg';
import DiscoverLogo from '~/assets/img/creditCards/discover.png';
import JCBLogo from '~/assets/img/creditCards/jcb.png';
import MastercardLogo from '~/assets/img/creditCards/mastercard.svg';
import UnionPayLogo from '~/assets/img/creditCards/unionpay.png';
import VisaLogo from '~/assets/img/creditCards/visa.svg';
import { PaymentCardBrand } from '~/services/BillingService';

export function getPaymentMethodBrandString(brand: PaymentCardBrand) {
    switch (brand) {
        case PaymentCardBrand.AmericanExpress:
            return 'American Express';
        case PaymentCardBrand.DinersClub:
            return 'Diners Club';
        case PaymentCardBrand.Discover:
            return 'Discover';
        case PaymentCardBrand.JCB:
            return 'JCB';
        case PaymentCardBrand.Mastercard:
            return 'Mastercard';
        case PaymentCardBrand.Visa:
            return 'Visa';
        case PaymentCardBrand.UnionPay:
            return 'UnionPay';
        case PaymentCardBrand.Unknown:
        default:
            return 'Unknown';
    }
}

export function getPaymentMethodBrandLogo(brand: PaymentCardBrand) {
    switch (brand) {
        case PaymentCardBrand.AmericanExpress:
            return AmericanExpressLogo;
        case PaymentCardBrand.DinersClub:
            return DinersClubLogo;
        case PaymentCardBrand.Discover:
            return DiscoverLogo;
        case PaymentCardBrand.JCB:
            return JCBLogo;
        case PaymentCardBrand.Mastercard:
            return MastercardLogo;
        case PaymentCardBrand.Visa:
            return VisaLogo;
        case PaymentCardBrand.UnionPay:
            return UnionPayLogo;
        case PaymentCardBrand.Unknown:
        default:
            return '';
    }
}
